import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Col } from "reactstrap";
import { AiFillCamera } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../assets/styles/style.css";
import "../../assets/styles/Profile.css";
import "../../assets/styles/Settings/Settings.css"
import { firstStepAction, logout } from "../../redux/actions/auth/auth.actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BsPlusLg } from "react-icons/bs";
import PresonalSecondStep from "../Presonal Steps/PresonalSecondStep";
import InputTags from '@semcore/ui/input-tags';
import Tooltip from "@semcore/tooltip";
import { IoMdCamera } from "react-icons/io";
import ProfileImage from "../../Pages/My-Profile/ProfileImage";
import { useTranslation } from "react-i18next";
import { Slide, toast, ToastContainer } from "react-toastify";

function BussinessSteps() {
  const { t } = useTranslation();
  const UserData = useSelector((state) => state?.auth?.user?.user);
  const [Offers, SetOffers] = useState([]);
  const [value3, updateValue3] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [First, setFirst] = useState("1");
  const [Image, setImage] = useState("");
  const [ImageCover, setImageCover] = useState("");
  const [ProfilePicPopup, setProfilePicPopup] = useState(false);
  const [CoverPicPopup, setCoverPicPopup] = useState(false);
  const inputFile = useRef(null);
  const inputFileCover = useRef(null);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const openInputFile = (e) => {
    inputFile.current.click();
  };

  const openInputFileCover = (e) => {
    inputFileCover.current.click();
  };

  useEffect(() => {
    if (!CoverPicPopup) {
      // Reset input value when CoverPicPopup is false
      inputFileCover.current.value = null;
    }
    if (!ProfilePicPopup) {
      // Reset input value when ProfilePicPopup is false
      inputFile.current.value = null;
    }
  }, [CoverPicPopup, ProfilePicPopup]);

  const handleImageChange = (e) => {
    inputFile.current.click();
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        setImage(e.target.result);
        // setIsUpload(true);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
    setProfilePicPopup(true)
  };

  const handleImageChangeCover = (e) => {
    inputFileCover.current.click();
    // setFilesCover(e.target.files[0]);
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        setImageCover(e.target.result);
        // setIsUploadCover(true);
      };
      reader.readAsDataURL(e.target.files[0]);
      setCoverPicPopup(true)
    }
  };
  const handleClose = (e) => {
    dispatch(logout());
    navigate("/about", { replace: true });
    localStorage.clear();
  };
  // to select dialCode and input value
  const handleOnChange = (value, data) => {
    setPhone(value.slice(data.dialCode.length));
    setCountryCode((data.countryCode).toUpperCase());
  };

  const notify = (val) => {
    if (val === "2")
      toast.info(t("premiumOffer"), { style: { border: '2px solid rgb(192, 192, 192)' } });
  }

  // initial values
  const inputValues = {
    status: 1,
    summary: "",
    url: "",
    bsCategory: "",
    bsSub_Type: "",
    bsName: "",
  };

  // Payload send to backend
  const payloadFirst = {
    address: "",
    country_code: "",
    phone_number: "",
    business_summary: "",
    about_company: "",
    activation_status: 1,
    email: "",
    business_category: "",
    sub_type: "",
    business_name: "",
    user_name: "",
  };

  //Business List
  const businessTypes = [
    { id: 0, name: "Real Estate / Construction" },
    { id: 1, name: "Food / Beverage" },
    { id: 2, name: "Clothing / Apparel" },
    { id: 3, name: "Coaching / Consultation" },
    { id: 4, name: "Antiques" },
    { id: 5, name: "Art" },
    { id: 6, name: "Books" },
    { id: 7, name: "Electronics" },
    { id: 8, name: "Music" },
    { id: 9, name: "Home / Garden" },
    { id: 10, name: "Beauty / Wellness" },
    { id: 11, name: "Sports" },
    { id: 12, name: "Entertainment" },
    { id: 13, name: "Culture" },
    { id: 14, name: "Vehicles" },
    { id: 15, name: "Furniture" },
    { id: 16, name: "Fabric / Textiles" },
    { id: 17, name: "Medical / Dental" },
    { id: 18, name: "Health / Fitness" },
    { id: 19, name: "Tools / Hardware" },
    { id: 20, name: "Toys / Hobbies / Crafts" },
    { id: 21, name: "Luggage / Bags / Cases" },
    { id: 22, name: "Business Services" },
    { id: 23, name: "Industrial" },
    { id: 24, name: "Outdoors / Recreation" },
    { id: 25, name: "Hotels / Motels / Resorts" },
    { id: 26, name: "Travel Arrangements" },
    { id: 27, name: "Leisure, Travel & Tourism" },
  ];

  const payloadFirstFunc = (values) => {
    payloadFirst.address = values.url;
    payloadFirst.phone_number = phone;
    payloadFirst.business_summary = values.summary;
    payloadFirst.about_company = Offers;
    payloadFirst.activation_status = 1;
    payloadFirst.country_code = countryCode;
    payloadFirst.email = UserData.email;
    payloadFirst.business_name = values.bsName;
    payloadFirst.user_name = values.bsName;
    payloadFirst.business_category = values.bsCategory;
    payloadFirst.sub_type = values.bsSub_Type;
  };

  const handleSubmit = (values) => {
    if (Offers.length > 0) {
      payloadFirstFunc(values);
      console.log(payloadFirst);
      dispatch(firstStepAction(payloadFirst));
      setFirst();
    }
  };

  const validationSchema = Yup.object().shape({
    url: Yup.string(t("fillField")).required(),
    summary: Yup.string(t("fillField")).required(),
    bsCategory: Yup.string(t("fillField")).required(),
    bsName: Yup.string(t("fillField")).required(),
    bsSub_Type: Yup.string(t("fillField")).required(),
  });

  // Business Offers Func Input Tags
  const handleAppendOff = (newTags) => {
    SetOffers((Offers) => [...Offers, ...newTags]);
    updateValue3("");
  };
  const handleRemoveOff = () => {
    if (Offers.length === 0) return;
    SetOffers(Offers.slice(0, -1));
    updateValue3(Offers.slice(-1)[0] + ` ${value3}`);
  };
  const handleCloseOff = (e) => {
    e.preventDefault();
  };

  const handleEditOff = (e) => {
    const { dataset } = e.currentTarget;
    let allTags = [...Offers];
    if (value3) {
      allTags = [...allTags, value3];
    }
    SetOffers(allTags.filter((tag, ind) => ind !== Number(dataset.id)));
    if (!e.defaultPrevented) {
      updateValue3(Offers[dataset.id]);
    }
    return false;
  };

  const handleBlurInputOff = (e) => {
    const { value } = e.currentTarget;
    if (value) handleAppendOff([value]);
  };

  // focus input on click
  const handleClick = () => {
    handleBlurInputOff()
  };

  return (
    <>
      {First ? (
        <Formik
          initialValues={inputValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            touched,
            isValid,
            dirty,
          }) => (
            <Col md="12" lg="12" sm="12" xm="12">

              {/* First Step */}
              <div className="full-content">
                <div className="text-center mt-5 mb-4 pt-4">
                  <img src="/img/Logo.png" height={60} alt="ibouge" />
                </div>

                {/* Card */}
                <div className="bg-white card-customize pb-2 mb-4">
                  <div className="border_top"></div>
                  <h6 className="headingSteps">{t('step_oneFour')}</h6>
                  <p className="setupHeading text-center">{t('setup_profile')}</p>
                  {/* Response Message */}
                  {(errors.url || errors.summary) &&
                    (touched.url ||
                      touched.summary) ? (
                    <div className="mt-2 mb-2 error-text">
                      {t("fillField")}
                    </div>
                  ) : ( null )}

                  {/* Image and Cover */}
                  <div className="position-relative text-center text-dark  ">
                    {/* user data */}
                    <div className="overflow-hidden text-center mx-2" style={{ borderRadius: "10px" }}>
                      <div
                        style={{
                          position: "absolute",
                          right: "0px",
                          top: "0px",
                          padding: "5px",
                          cursor: "pointer",
                          borderRadius: "8px",
                        }}
                        onClick={openInputFileCover}
                        onChange={handleImageChangeCover}
                      >
                        <AiFillCamera size={28} color={"White"} />
                        <span className="ms-1"></span>
                      </div>

                      <div>
                        <img
                          className="Settingcover"
                          src={
                            UserData?.cover_pic
                              ? UserData?.cover_pic
                              : "/Images/dummy2.png"
                          }
                          alt={`${UserData?.fname} ${UserData?.lname}`}
                        />
                      </div>

                      <input
                        type="file"
                        id="file"
                        className="rounded-circle photouser"
                        ref={inputFileCover}
                        onClick={openInputFileCover}
                        onChange={handleImageChangeCover}
                        accept="image/png, image/jpeg"
                        style={{ display: "none" }}
                      />
                      <div style={{ position: "absolute", top: "30px" }} className="w-100 mx-auto">

                        <img
                          className="ms-img img-fluid"
                          src={UserData?.profile_pic ? UserData?.profile_pic : "/img/upload-photo.png"}
                          alt="Icon"
                        />

                        <input
                          type="file"
                          id="file"
                          className="rounded-circle photouser"
                          ref={inputFile}
                          onClick={openInputFile}
                          accept="image/png, image/jpeg"
                          onChange={handleImageChange}
                          style={{ display: "none" }}
                        />
                        <IoMdCamera
                          className="s-camera p-2 rounded-5 "
                          onClick={openInputFile}
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>
                  </div>
                  <h3 className="userNameStep text-center mt-5 pt-2">{UserData?.fname}</h3>

                  {/* Bussiness Account */}
                  <div className="mt-3 position-relative px-4">
                    <label className="Labelsignup">{t('businessCategory')}</label>
                    <select
                      className="form-select form-select-sm AccountType"
                      value={values.bsCategory}
                      name="bsCategory"
                      onChange={handleChange}
                    >
                      <option value="" className="text-danger" disabled hidden>
                        {t('businessCategory')}
                      </option>
                      {businessTypes.map((items) => {
                        return (
                          <option value={items.name} key={items.id}>
                            {items.name}
                          </option>
                        );
                      })}
                    </select>
                    {errors.bsCategory && touched.bsCategory ? (
                      <div className="error-text">{errors.bsCategory}</div>
                    ) : null}
                  </div>
                  <div className="mt-3 position-relative px-4">
                    <label className="Labelsignup">{t('subscriptionType')}</label>
                    <select
                      className="form-select form-select-sm AccountType"
                      value={values.bsSub_Type}
                      name="bsSub_Type"
                      onChange={(e) => {
                        handleChange(e);
                        notify(e.target.value);
                      }}
                    >
                      <option value="" className="" disabled hidden>
                        {t('selectPlan')}
                      </option>
                      <option value="1" className="">
                        {t('freePlan')}
                      </option>
                      <option value="2" className="">
                        {t('premiumPlan')}
                      </option>
                    </select>
                    {errors.bsSub_Type && touched.bsSub_Type ? (
                      <div className="error-text">{errors.bsSub_Type}</div>
                    ) : null}
                  </div>
                  <div className="mt-3 position-relative px-4 mt-2">
                    <label className="Labelsignup">{t('businessName')}</label>
                    <input
                      className="form-control input-btn"
                      type="text"
                      placeholder={t("businessName")}
                      name="bsName"
                      value={values.bsName}
                      onChange={handleChange}
                    />
                    {errors.bsName && touched.bsName ? (
                      <div className="error-text">{errors.bsName}</div>
                    ) : null}
                  </div>


                  {/* details */}
                  <div className="">
                    <label className="LabelStep">{t('businessSummary')}</label>
                    <div className="d-flex justify-content-around px-4">
                      <textarea
                        name="summary"
                        placeholder={t('businessSummary_placeholder')}
                        className="form-control step-input-btn"
                        rows="1"
                        value={values.summary}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                  {/* contact form */}
                  <label className="LabelStep">{t('businessContact')}</label>
                  <div className="d-flex justify-content-center ms-4 pe-4">
                    <PhoneInput
                      name="Phone"
                      specialLabel={""}
                      country={"us"}
                      inputClass={"step-input-btn"}
                      placeholder="201-555-0123"
                      // countrydata={dialCode}
                      value="phone"
                      onChange={handleOnChange}
                    />
                  </div>
                  <label className="LabelStep">{t('companyWebsite')}</label>
                  <div className="col d-flex justify-content-center px-4">
                    <input
                      name="url"
                      type="url"
                      className="form-control step-input-btn"
                      value={values.url}
                      onChange={handleChange}
                    />
                  </div>
                  {/* What does your Business offers? */}
                  <label className="LabelStep">
                    {t('businessOffers')}
                  </label>
                  <div className="d-flex flex-column align-items-center px-4">
                    <InputTags size="l"
                      style={{ padding: "10px 10px" }}
                      className="step-input-btn form-control"
                      onAppend={handleAppendOff}
                      onRemove={handleRemoveOff}>
                      {Offers.length < 0 ? null :
                        Offers.map((tag, idx) => (
                          <Tooltip key={idx}>
                            <Tooltip.Trigger
                              tag={InputTags.Tag}
                              theme="primary"
                              data-id={idx}
                              onClick={handleEditOff}
                            >
                              <InputTags.Tag.Text>{tag}</InputTags.Tag.Text>
                              <InputTags.Tag.Close onClick={handleCloseOff} />
                            </Tooltip.Trigger>
                          </Tooltip>
                        ))}
                      <InputTags.Value
                        value={value3}
                        onChange={updateValue3}
                        onBlur={handleBlurInputOff}
                      />
                    </InputTags>
                    <div className="Addrefinput w-100">
                      <p className="Addbtnp" onClick={handleClick}>
                        {t('addProduct')}
                        <BsPlusLg
                          className="BsPlusLg-icon"
                          color="white"
                          size={14}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center px-4 pt-3 pb-2">
                    <Button
                      name="submit"
                      type="submit"
                      className="submit-butn w-100"
                      style={{ opacity: Offers.length > 0 ? 1 : 0.4 }}
                      disabled={!(dirty && isValid)}
                      onClick={handleSubmit}
                    >
                      {t('continue')}
                    </Button>
                  </div>
                </div>
              </div>
              <AiOutlineClose
                size={30}
                className="aioutline"
                onClick={handleClose}
              />
            </Col>
          )}
        </Formik>
      ) : (
        <PresonalSecondStep />
      )}

      {ProfilePicPopup === true ? (
        <ProfileImage
          src={Image}
          Full={inputFile.current.files[0]}
          handleClose={() => setProfilePicPopup(false)}
          type={"profile"}
        />
      ) : null}
      {CoverPicPopup === true ? (
        <ProfileImage
          src={ImageCover}
          Full={inputFileCover.current.files[0]}
          handleClose={() => setCoverPicPopup(false)}
          type={"Cover"}
        />
      ) : null}

      <ToastContainer
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        position="bottom-center"
        autoClose={5000}
        limit={1}
        newestOnTop={false}
        hideProgressBar
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        theme="light"
        transition={Slide}
      />
    </>
  );
}

export default BussinessSteps;